import type { MediaSubtitleSidecar } from '@/types/storage'
import { createLogger } from '@/shared/logging/logger'

import { requireWorkspaceRoot } from './root'
import { readJson, removeEntry, writeJsonAtomic } from './fs-primitives'
import { mediaSubtitleSidecarPath } from './paths'

const logger = createLogger('WorkspaceFS:SubtitleSidecars')

export async function getSubtitleSidecar(
  mediaId: string,
): Promise<MediaSubtitleSidecar | undefined> {
  try {
    const root = requireWorkspaceRoot()
    const record = await readJson<MediaSubtitleSidecar>(root, mediaSubtitleSidecarPath(mediaId))
    return record ?? undefined
  } catch (error) {
    logger.error(`getSubtitleSidecar(${mediaId}) failed`, error)
    throw new Error(`Failed to load subtitle sidecar: ${mediaId}`)
  }
}

export async function saveSubtitleSidecar(
  sidecar: MediaSubtitleSidecar,
): Promise<MediaSubtitleSidecar> {
  try {
    const root = requireWorkspaceRoot()
    await writeJsonAtomic(root, mediaSubtitleSidecarPath(sidecar.mediaId), sidecar)
    return sidecar
  } catch (error) {
    logger.error(`saveSubtitleSidecar(${sidecar.mediaId}) failed`, error)
    throw new Error(`Failed to save subtitle sidecar: ${sidecar.mediaId}`)
  }
}

export async function deleteSubtitleSidecar(mediaId: string): Promise<void> {
  try {
    const root = requireWorkspaceRoot()
    await removeEntry(root, mediaSubtitleSidecarPath(mediaId))
  } catch (error) {
    logger.error(`deleteSubtitleSidecar(${mediaId}) failed`, error)
    throw new Error(`Failed to delete subtitle sidecar: ${mediaId}`)
  }
}